import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import DarkModeToggle from "react-dark-mode-toggle";
import "../assets/css/HeaderWebsite.css";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Modal } from "react-bootstrap";
import { linkWhatsapp, linkYoutube, linkInstagram } from "../global/GlobalVariables";
import supportLogoDark from "../assets/svg/headset-dark-mode.svg";
import supportLogoLight from "../assets/svg/headset-light-mode.svg";
function HeaderPageExtension(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
    user,
  } = props;
  const wpplogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-whatsapp-96.png`;
  const instalogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-instagram-96.png`;
  const youtlogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-reproduzir-youtube-96.png`;
  const wpplogop = `${process.env.PUBLIC_URL}/svgimagens/icons8-whatsapp-96-preto.png`;
  const instalogop = `${process.env.PUBLIC_URL}/svgimagens/icons8-instagram-96-preto.png`;
  const youtlogop = `${process.env.PUBLIC_URL}/svgimagens/icons8-reproduzir-youtube-96-preto.png`;
  const logopreto = `${process.env.PUBLIC_URL}/LOGOPRETO.png`;
  const logobranca = `${process.env.PUBLIC_URL}/LOGOBRANCO.png`;
  const somon = `${process.env.PUBLIC_URL}/images/apitosomon.png`;
  const somoff = `${process.env.PUBLIC_URL}/images/apitosomoff.png`;
  const somonp = `${process.env.PUBLIC_URL}/images/apitosomonp.png`;
  const somoffp = `${process.env.PUBLIC_URL}/images/apitosomoffp.png`;

  const [showV, setShowV] = useState(false);

  const handleCloseV = () => setShowV(false);
  const handleShowV = () => setShowV(true);

  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn]);
  useEffect(() => {
    if (statusMode) {
      document.documentElement.className = "dark-theme";
      document.documentElement.setAttribute("data-bs-theme", "dark-theme");
    } else {
      document.documentElement.className = "light-theme";
      document.documentElement.setAttribute("data-bs-theme", "light-theme");
    }
    localStorage.setItem("theme", statusMode);
  }, [statusMode]);

  const shouldShowLogoutButton = () => {
    const hash = window.location.hash;

    if (hash === "" || hash === "/") {
      return true;
    }

    if (hash.includes("/calculator/")) {
      return false;
    }

    if (hash.includes("/calculator/")) {
      return false;
    }

    const currentPath = window.location.pathname;

    if (currentPath === "/") {
      return true;
    }

    if (currentPath.includes("/calculator/")) {
      return false;
    }

    return true;
  };

  const [volume, setVolume] = useState(notificationVolume);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {}, [volume]);

  const handleVolumeChange = (event) => {
    const newVolume = parseFloat(event.target.value);
    setNotificationVolume(newVolume);
    localStorage.setItem("volume", JSON.stringify(newVolume));
    setVolume(newVolume);
    setIsMuted(newVolume === 0);
    setNotificationVolume(parseFloat(event.target.value));
  };

  useEffect(() => {
    const savedVolume = JSON.parse(localStorage.getItem("volume"));

    if (savedVolume !== null) {
      setNotificationVolume(savedVolume);
    }
    changeStatusModes(statusMode);
  }, []);
  const changeStatusModes = (oldStatusMode) => {
    setStatusMode(oldStatusMode);

    window.localStorage.setItem("statusMode", JSON.stringify(oldStatusMode));
    const dataToJson = JSON.stringify(oldStatusMode);
    localStorage.setItem("statusMode", dataToJson);
    document.body.style.backgroundColor = !oldStatusMode ? "" : "#0d0d0d";
  };

  const changeStatusMode = (oldStatusMode) => {
    setStatusMode(!oldStatusMode);
    const dataToJson = JSON.stringify(!oldStatusMode);
    localStorage.setItem("statusMode", dataToJson);
    document.body.style.backgroundColor = oldStatusMode ? "" : "#0d0d0d";
  };

  return (
    <>
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          expand={false}
          className={`bg-body-tertiary header d-flex justify-content-between align-items-center navbar navbar-expand-xxl zete  navbar-dark ResponsivHeader ${
            statusMode ? "dark-mode" : ""
          }`}
        >
          <Container fluid>
            <Navbar.Brand href="#" style={{ margin: "0" }}>
              <NavLink to="/">
                <a
                  className={`text-decoration-none fs-5 me-3 ${
                    statusMode ? "textDark" : "text-light"
                  }`}
                >
                  <img
                    src={statusMode ? logobranca : logopreto}
                    alt="Logo"
                    style={{ height: "55px", width: "auto" }}
                    className="imgfullhd"
                  />
                </a>
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-xxl`}
              className="margin20px"
            />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-xxl`}
              aria-labelledby={`offcanvasNavbarLabel-expand-xxl`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xxl`}>
                  <a
                    className={`text-decoration-none fs-5 me-3 ${
                      statusMode ? "textDark" : "text-light"
                    }`}
                    href="/"
                  >
                    <img
                      src={logobranca}
                      alt="Logo"
                      style={{ height: "55px", width: "auto" }}
                      className="imgfullhd"
                    />
                  </a>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {shouldShowLogoutButton() && (
                  <div className="social div-social-media">
                    <a
                      href={linkInstagram}
                      target="_blank"
                      rel="noreferrer"
                      className="social-link"
                    >
                      <img
                        src={statusMode ? instalogo : instalogop}
                        alt="Instagram"
                        className="social-icon insta"
                      />
                    </a>
                    <div className="space-icon"></div>
                    <a
                      href={linkYoutube}
                      target="_blank"
                      rel="noreferrer"
                      className="social-link"
                    >
                      <img
                        src={statusMode ? youtlogo : youtlogop}
                        alt="YouTube"
                        className="social-icon youtube"
                      />
                    </a>
                    <div className="space-icon"></div>
                    <a
                      href={linkWhatsapp}
                      target="_blank"
                      rel="noreferrer"
                      className="social-link"
                    >
                      <img
                        src={statusMode ? supportLogoDark : supportLogoLight}
                        alt="Suport Logo"
                        className="social-icon"
                      />
                    </a>
                  </div>
                )}

                <div className="div-btn-menu menu mudanca-menu">
                  {shouldShowLogoutButton() && (
                    <>
                      <div className="menu mudanca-menu">
                        <ul
                          className={`div-list-btn-menu menu-links ${
                            statusMode ? "textDark" : "text-light"
                          } `}
                        >

                          {userData && userData.username === "admin" && (
                            <div>
                              <NavLink to="/dashboard">
                                <li className="nav-link">
                                  <span className="navlink">
                                    <a className="linknavbar">
                                      <b
                                        className={`  ${
                                          statusMode ? "text-light" : "textDark"
                                        }`}
                                      >
                                        DASHBOARD
                                      </b>
                                    </a>
                                  </span>
                                </li>
                              </NavLink>
                            </div>
                          )}
                          <div>
                            <NavLink to="/config">
                              <li className="nav-link">
                                <span className="navlink">
                                  <a className="linknavbar">
                                    <b
                                      className={`  ${
                                        statusMode ? "text-light" : "textDark"
                                      }`}
                                    >
                                      CONTA{" "}
                                    </b>
                                  </a>
                                </span>
                              </li>
                            </NavLink>
                          </div>

                          {userData && userData.username === "moderador" && (
                            <div>
                              <NavLink to="/bonus/list">
                                <li className="nav-link">
                                  <span className="navlink">
                                    <a className="linknavbar">
                                      <b
                                        className={` ${
                                          statusMode ? "text-light" : "textDark"
                                        }`}
                                        style={{whiteSpace:"nowrap"}}
                                      >
                                        CALCULADORA BÔNUS
                                      </b>
                                    </a>
                                  </span>
                                </li>
                              </NavLink>
                            </div>
                          )}
                          <div>
                            <NavLink to="/">
                              <li className="nav-link btn-back-to-bet-page-present-extension">
                                <span className="navlink">
                                  <a className="linknavbar">
                                    <b
                                      className={`  ${
                                        statusMode ? "text-light" : "textDark"
                                      }`}
                                    >
                                      VOLTAR AS APOSTAS
                                    </b>
                                  </a>
                                </span>
                              </li>
                            </NavLink>
                          </div>
                        </ul>
                      </div>
                    </>
                  )}
                </div>
                <Navbar.Collapse
                  className="justify-content-end navbar-end"
                  style={{ display: "ruby-text", justifyContent: "center" }}
                >
                  <Navbar.Text>
                    <div className="d-flex align-items-center ">
                      {shouldShowLogoutButton() && (
                        <div>
                          <img
                            onClick={handleShowV}
                            src={
                              volume > 0
                                ? statusMode
                                  ? somon
                                  : somonp
                                : statusMode
                                  ? somoff
                                  : somoffp
                            }
                            alt="Ícone de volume"
                            style={{ height: "35px", width: "auto" }}
                          />

                          <Modal
                            show={showV}
                            onHide={handleCloseV}
                            centered
                            style={{ display: "grid" }}
                          >
                            <Modal.Body
                              className={` modal-content-vol ${
                                statusMode ? "backblack" : ""
                              }`}
                              style={{
                                background: `  ${
                                  statusMode ? "backblack" : ""
                                }`,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Modal.Title>Volume</Modal.Title>

                              <img
                                src={statusMode ? somon : somonp}
                                alt="Ícone de volume"
                                style={{ height: "35px", width: "auto" }}
                              />
                              <hr />
                              <hr />
                              <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.01"
                                value={volume}
                                onChange={handleVolumeChange}
                                style={{
                                  transform: "rotate(270deg)",
                                  width: "100%",
                                }}
                              />
                              <hr />
                              <hr />
                              <img
                                src={statusMode ? somoff : somoffp}
                                alt="Ícone de volume"
                                style={{ height: "35px", width: "auto" }}
                              />
                            </Modal.Body>
                          </Modal>
                        </div>
                      )}
                      <div
                        className={`form-check form-switch me-2 ${
                          statusMode ? "dark-switch" : ""
                        }`}
                      >
                        <DarkModeToggle
                          className="toggler"
                          size={70}
                          speed={1.3}
                          onChange={() => changeStatusMode(statusMode)}
                          checked={statusMode}
                        />
                      </div>
                    </div>
                  </Navbar.Text>
                </Navbar.Collapse>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default HeaderPageExtension;
